import { render, staticRenderFns } from "./TopTitle2.vue?vue&type=template&id=2f466b50&scoped=true&"
import script from "./TopTitle2.vue?vue&type=script&lang=js&"
export * from "./TopTitle2.vue?vue&type=script&lang=js&"
import style0 from "./TopTitle2.vue?vue&type=style&index=0&id=2f466b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f466b50",
  null
  
)

export default component.exports